export const HEADER_USER_ACCOUNT_ID = 'X-Signater-User-Account-Id'
export const HEADER_SANDBOX_MODE = 'X-Signater-Sandbox-Mode'
export const HEADER_TELEMETRY_OPERATION_ID = 'X-Signater-Telemetry-Operation-Id'
export const HEADER_MANAGED_ACCOUNT_ID = 'X-Signater-Managed-Account-Id'
export const HEADER_APP_VERSION = 'X-Signater-App-Version'
/** Honored by non-prod backends only; see the dev guard in api-client.utils. */
export const HEADER_CAPTCHA_BYPASS = 'X-Signater-Captcha-Bypass'

export const AUTH_LOGIN_ENDPOINT = '/v1/auth/login'
export const AUTH_REFRESH_ENDPOINT = '/v1/auth/refresh'
